const getCurrentEnv = () => {
  const isLocal = window?.location?.href?.includes('localhost');
  const isStage = window?.location?.href?.includes('stage-www');
  const isProduction = window?.location?.href?.includes('svensktnaringsliv.se');

  return isLocal ? 'localhost' : isStage ? 'stage' : isProduction ? 'production' : undefined;
};

export default getCurrentEnv;
